import { render, staticRenderFns } from "./RelatedCompanyListContainer.vue?vue&type=template&id=13b895b4"
import script from "./RelatedCompanyListContainer.vue?vue&type=script&lang=js"
export * from "./RelatedCompanyListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports